import { render } from "./CgWorkShopTerms.vue?vue&type=template&id=21f8ca0a&scoped=true"
import script from "./CgWorkShopTerms.vue?vue&type=script&lang=js"
export * from "./CgWorkShopTerms.vue?vue&type=script&lang=js"

import "./CgWorkShopTerms.vue?vue&type=style&index=0&id=21f8ca0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f8ca0a"]])

export default __exports__